import { render, staticRenderFns } from "./change_state_star_zen_page.vue?vue&type=template&id=1ca7008a&scoped=true"
import script from "./change_state_star_zen_page.vue?vue&type=script&lang=js"
export * from "./change_state_star_zen_page.vue?vue&type=script&lang=js"
import style0 from "./change_state_star_zen_page.vue?vue&type=style&index=0&id=1ca7008a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7008a",
  null
  
)

export default component.exports